export default "__VITE_ASSET__Cy3D0CCL__"